export default __webpack_public_path__ + "static/media/wc.85161662.svg";